type KeyboardLayouts = Record<string, string[]>;

const BASE_VIRTUAL_KEYBOARD_LAYOUTS: KeyboardLayouts = {
    default: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
        "{tab} q w e r t y u i o p [ ] \\",
        "{lock} a s d f g h j k l ; ' {enter}",
        "{shift} z x c v b n m , . / {shift}",
        ".com @ {space}",
    ],
    shift: [
        "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
        "{tab} Q W E R T Y U I O P { } |",
        '{lock} A S D F G H J K L : " {enter}',
        "{shift} Z X C V B N M < > ? {shift}",
        ".com @ {space}",
    ],
    symbols: [
        "[ ] { } # % ^ * + =",
        "_ \\ | ~ < > € £ ¥ ·",
        "{abc} {numbers} . , ? ! ' {backspace}",
        "{space}",
    ],
    numbersComplete: [
        "1 2 3 4 5 6 7 8 9 0",
        '- / : ; ( ) $ & @ "',
        "{abc} {symbols} . , ? ! ' {backspace}",
        "{space}",
    ],
    numbers: [
        "1 2 3",
        "4 5 6",
        "7 8 9",
        "{backspace} 0 {enter}",
        "{mobileKeyboard}",
    ],
    numbersWithUpAndDownArrows: [
        "1 2 3 {arrowup}",
        "4 5 6 {arrowdown}",
        "7 8 9 {tab}",
        "{numpaddecimal} 0 {backspace} {clear}",
    ],
    phone: [
        "1 2 3 4 5",
        "6 7 8 9 0",
        "+ ( ) / -",
        "{space} {backspace} {enter}",
    ],
    // wideNumbersWithUpAndDownArrows: [
    //     "1 2 3 4 {arrowup}",
    //     "5 6 7 8 {arrowdown}",
    //     "9 0 {numpaddecimal} {backspace}",
    // ],
    mobile: [
        "1 2 3 4 5 6 7 8 9 0",
        "q w e r t y u i o p",
        "a s d f g h j k l",
        "{shift} z x c v b n m {backspace}",
        "{numbers} , {space} . {enter}",
    ],
    mobileShift: [
        "~ ! @ # $ % ^ & * ( ) - +",
        "Q W E R T Y U I O P",
        "A S D F G H J K L",
        "{shift} Z X C V B N M {backspace}",
        "{numbers} , {space} . {enter}",
    ],
    emailMobile: [
        "1 2 3 4 5 6 7 8 9 0",
        "q w e r t y u i o p",
        "a s d f g h j k l @",
        "{shift} z x c v b n m . {backspace}",
        ".com _ {space} - {enter}",
    ],
    emailMobileShift: [
        "~ ! @ # $ % ^ & * ( ) - +",
        "Q W E R T Y U I O P",
        "A S D F G H J K L @",
        "{shift} Z X C V B N M . {backspace}",
        ".com _ {space} - {enter}",
    ],
};

const LANGUAGE_LAYOUT_OVERRIDES: Record<string, Partial<KeyboardLayouts>> = {
    // Add future languages here with only the layouts that differ from the base set.
    ar: {
        mobile: [
            "١ ٢ ٣ ٤ ٥ ٦ ٧ ٨ ٩ ٠",
            "ض ص ث ق ف غ ع ه خ ح ج د",
            "ش س ي ب ل ا ت ن م ك ط",
            "{shift} ئ ء ؤ ر لا ى ة و ز ظ {backspace}",
            "{numbers} ، {space} . {enter}",
        ],
        mobileShift: [
            "1 2 3 4 5 6 7 8 9 0",
            "َ ً ُ ٌ ل إ ئ / × ؛ < >",
            "ِ ٍ ] [ ٓ آ ـ ، / : \"",
            "{shift} ~ ْ } { { لأ أ ٔ | {backspace}",
            "{numbers} ، {space} . {enter}",
        ],
    },
    de: {
        default: [
            "^ 1 2 3 4 5 6 7 8 9 0 ß ´ {bksp}",
            "{tab} q w e r t z u i o p ü + #",
            "{lock} a s d f g h j k l ö ä {enter}",
            "{shift} < y x c v b n m , . - {shift}",
            ".com @ {space}",
        ],
        shift: [
            "° ! \" § $ % & / ( ) = ? ` {bksp}",
            "{tab} Q W E R T Z U I O P Ü * '",
            "{lock} A S D F G H J K L Ö Ä {enter}",
            "{shift} > Y X C V B N M ; : _ {shift}",
            ".com @ {space}",
        ],
        mobile: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t z u i o p",
            "a s d f g h j k l ö ä",
            "{shift} y x c v b n m ü ß {backspace}",
            "{numbers} , {space} . {enter}",
        ],
        mobileShift: [
            "~ ! @ # $ % ^ & * ( ) - +",
            "Q W E R T Z U I O P",
            "A S D F G H J K L Ö Ä",
            "{shift} Y X C V B N M Ü ẞ {backspace}",
            "{numbers} , {space} . {enter}",
        ],
        emailMobile: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t z u i o p",
            "a s d f g h j k l ö ä ß",
            "{shift} y x c v b n m ü @ {backspace}",
            ".com _ {space} - {enter}",
        ],
        emailMobileShift: [
            "~ ! @ # $ % ^ & * ( ) - +",
            "Q W E R T Z U I O P",
            "A S D F G H J K L Ö Ä ẞ",
            "{shift} Y X C V B N M Ü @ {backspace}",
            ".com _ {space} - {enter}",
        ],
    },
    es: {
        mobile: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t y u i o p",
            "a s d f g h j k l ñ",
            "{shift} z x c v b n m á é í ó ú {backspace}",
            "{numbers} , {space} . {enter}",
        ],
        mobileShift: [
            "¡ ! ¿ ? @ # € % & / ( )",
            "Q W E R T Y U I O P",
            "A S D F G H J K L Ñ",
            "{shift} Z X C V B N M Á É Í Ó Ú {backspace}",
            "{numbers} , {space} . {enter}",
        ],
    },
    fa: {
        mobile: [
            "۱ ۲ ۳ ۴ ۵ ۶ ۷ ۸ ۹ ۰",
            "ض ص ث ق ف غ ع ه خ ح ج چ",
            "ش س ی ب ل ا ت ن م ک گ",
            "{shift} ظ ط ز ر ذ د پ و . {backspace}",
            "{numbers} ، {space} . {enter}",
        ],
        mobileShift: [
            "1 2 3 4 5 6 7 8 9 0",
            "َ ً ُ ٌ ] [ } { آ ؤ ئ",
            "ِ ٍ ْ ّ » « : ؛ \" '",
            "{shift} ؟ ! / - _ + = | {backspace}",
            "{numbers} ، {space} . {enter}",
        ],
    },
    fr: {
        mobile: [
            "1 2 3 4 5 6 7 8 9 0",
            "a z e r t y u i o p",
            "q s d f g h j k l m",
            "{shift} w x c v b n é è à ç ù {backspace}",
            "{numbers} , {space} . {enter}",
        ],
        mobileShift: [
            "& é \" ' ( - è _ ç à ) =",
            "A Z E R T Y U I O P",
            "Q S D F G H J K L M",
            "{shift} W X C V B N É È À Ç Ù {backspace}",
            "{numbers} , {space} . {enter}",
        ],
    },
    it: {
        mobile: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t y u i o p",
            "a s d f g h j k l ò à",
            "{shift} z x c v b n m è é ì ù {backspace}",
            "{numbers} , {space} . {enter}",
        ],
        mobileShift: [
            "! \" £ $ % & / ( ) = ?",
            "Q W E R T Y U I O P",
            "A S D F G H J K L Ò À",
            "{shift} Z X C V B N M È É Ì Ù {backspace}",
            "{numbers} , {space} . {enter}",
        ],
    },
    ja: {
        mobile: [
            "1 2 3 4 5 6 7 8 9 0",
            "あ か さ た な は ま や ら わ",
            "い き し ち に ひ み ゆ り を",
            "{shift} う く す つ ぬ ふ む よ る ん {backspace}",
            "{numbers} 、 {space} 。 {enter}",
        ],
        mobileShift: [
            "ぁ ぃ ぅ ぇ ぉ ゃ ゅ ょ っ ー",
            "ア カ サ タ ナ ハ マ ヤ ラ ワ",
            "イ キ シ チ ニ ヒ ミ ユ リ ヲ",
            "{shift} ウ ク ス ツ ヌ フ ム ヨ ル ン {backspace}",
            "{numbers} 、 {space} 。 {enter}",
        ],
    },
    ru: {
        mobile: [
            "1 2 3 4 5 6 7 8 9 0",
            "й ц у к е н г ш щ з х",
            "ф ы в а п р о л д ж э",
            "{shift} я ч с м и т ь б ю {backspace}",
            "{numbers} , {space} . {enter}",
        ],
        mobileShift: [
            "! \" № ; % : ? * ( ) _",
            "Й Ц У К Е Н Г Ш Щ З Х",
            "Ф Ы В А П Р О Л Д Ж Э",
            "{shift} Я Ч С М И Т Ь Б Ю {backspace}",
            "{numbers} , {space} . {enter}",
        ],
    },
    tr: {
        mobile: [
            "1 2 3 4 5 6 7 8 9 0",
            "q w e r t y u ı o p ğ ü",
            "a s d f g h j k l ş i",
            "{shift} z x c v b n m ö ç {backspace}",
            "{numbers} , {space} . {enter}",
        ],
        mobileShift: [
            "! ' ^ + % & / ( ) = ? *",
            "Q W E R T Y U I O P Ğ Ü",
            "A S D F G H J K L Ş İ",
            "{shift} Z X C V B N M Ö Ç {backspace}",
            "{numbers} , {space} . {enter}",
        ],
    },
};

const layoutCache: Record<string, KeyboardLayouts> = {};
const alphaButtonsCache: Record<string, string> = {};

const normalizeVirtualKeyboardLanguageCode = (languageCode?: string | null) => (
    languageCode
        ?.toLowerCase()
        .split(/[-_]/)[0]
        || "en"
);

const isAlphabeticKey = (token: string) => {
    if (!token || token.startsWith("{")) return false;

    return Array.from(token).every((character) => (
        character.toLocaleLowerCase() !== character.toLocaleUpperCase()
    ));
};

export const getVirtualKeyboardLayouts = (languageCode?: string | null) => {
    const normalizedLanguageCode = normalizeVirtualKeyboardLanguageCode(languageCode);

    if (!layoutCache[normalizedLanguageCode]) {
        const nextLayouts: KeyboardLayouts = {
            ...BASE_VIRTUAL_KEYBOARD_LAYOUTS,
        };
        const languageOverrides = LANGUAGE_LAYOUT_OVERRIDES[normalizedLanguageCode];

        if (languageOverrides) {
            Object.entries(languageOverrides).forEach(([layoutName, rows]) => {
                if (rows) {
                    nextLayouts[layoutName] = rows;
                }
            });
        }

        layoutCache[normalizedLanguageCode] = nextLayouts;
    }

    return layoutCache[normalizedLanguageCode];
};

export const getVirtualKeyboardAlphaButtons = (languageCode?: string | null) => {
    const normalizedLanguageCode = normalizeVirtualKeyboardLanguageCode(languageCode);

    if (!alphaButtonsCache[normalizedLanguageCode]) {
        const layouts = getVirtualKeyboardLayouts(normalizedLanguageCode);
        const alphaButtons = new Set<string>();

        Object.values(layouts).forEach((rows) => {
            rows.forEach((row) => {
                row.split(" ").forEach((token) => {
                    if (isAlphabeticKey(token)) {
                        alphaButtons.add(token);
                    }
                });
            });
        });

        alphaButtonsCache[normalizedLanguageCode] = Array.from(alphaButtons).join(" ");
    }

    return alphaButtonsCache[normalizedLanguageCode];
};
